import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CtaButton } from '../ui/CtaButton';
import { bonuses } from '../../data/bonuses';
import { OFFER_ANCHOR } from '../../data/offer';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="bg-onyx" data-id="element-37" data-mp="1clzc0idd4o2w">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-38" data-mp="18k4c9ib2yir8">
        <div className="mx-auto max-w-3xl text-center" data-id="element-39" data-mp="18hhw4ua4iuxe">
          <h2 id="bonuses-heading" className="font-display text-5xl font-extrabold uppercase leading-[0.92] text-white md:text-6xl" data-id="element-40" data-mp="258silhdfohkt">
            Five <span className="text-gold" data-id="element-41" data-mp="1w8x3x2ko64g1">strategic bonuses</span>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/75" data-id="element-42" data-mp="1wazxfwl16fpi">Included free with HYROX MEGA PACK™ today.</p>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-6" data-id="element-43" data-mp="kujie4de2136">
          {bonuses.map((b, i) => <li key={b.number} className={`flex flex-col overflow-hidden rounded-xl border border-white/10 bg-card ${i < 2 ? 'lg:col-span-3' : 'lg:col-span-2'} ${i === 4 ? 'sm:col-span-2 lg:col-span-2' : ''}`} data-id="element-44" data-mp="funl0nz757wl" data-mpi={i}>
              <div className="relative aspect-[4/3] overflow-hidden bg-onyx" data-id="element-45" data-mp="15ti5e2gbalaq">
                <img src={b.cover} alt={`${b.title} cover`} loading="lazy" width={1024} height={1024} className="h-full w-full object-cover" data-id="element-46" data-mp="1as1pryf9bp0z" />
                <span className="absolute left-4 top-4 bg-gold px-2.5 py-1 text-xs font-bold uppercase tracking-wider text-forest" data-id="element-47" data-mp="10v6t7l2jnypc">
                  Bonus {b.number}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-48" data-mp="r1zsidir16vl">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-white md:text-[1.7rem]" data-id="element-49" data-mp="d5cipa5p6m89">
                  {b.title}
                </h3>
                <p className="mt-3 text-base leading-relaxed text-white/75" data-id="element-50" data-mp="2jsbjoslimg89">{b.description}</p>
                <p className="mt-auto pt-5" data-id="element-51" data-mp="2f1v2qyihkch5">
                  <span className="inline-flex items-center gap-1.5 border border-gold/50 px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-gold" data-id="element-52" data-mp="2f11x60v9jt0l">
                    <GiftIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-53" data-mp="261f5i6sc61kq" />
                    Included free
                  </span>
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-md" data-id="element-54" data-mp="2ypav6rjhmt80">
          <CtaButton href={OFFER_ANCHOR} fullWidth data-id="element-55" data-mp="2yqm4f6vpct6i">
            Get the pack + 5 bonuses
          </CtaButton>
        </div>
      </div>
    </section>;
}